export const WizardStepsForecasting = {
    TaskManager: 'TASKMANAGER',
    TaskWizard: 'TASKWIZARD',
    CustomiseBudget: 'BUDGETCUSTOMISE',
    CustomiseForecast: 'FORECASTCUSTOMISE',
    CustomiseScenario: 'SCENARIOCUSTOMISE',
    CustomiseDrivers: 'DRIVERSCUSTOMISE',
    CustomiseMeasures: 'MEASURESCUSTOMISE',
    CustomiseData: 'CUSTOMISEDATA',
    Settings: 'SETTINGS',
    CustomiseLayout: 'CUSTOMISELAYOUT',
    Preview: 'PREVIEW',
    Complete: 'COMPLETE',

    QB: 'QB',
    MyobAccountRight: 'MYOBACCOUNTRIGHT',
    Xero: 'XERO',
    Step3: 'step3',
    Step4: 'step4',
    Step5: 'step5',

    ManageGroup: 'MANAGEGROUP',
    CustomiseGroup: 'CUSTOMISEGROUP',
    AddDataSource: 'ADDDATASOURCE',
};

export enum ReportModes {
    Spotlight = 'SPOTLIGHT',
    Forecast = 'FORECAST',
    Dashboard = 'DASHBOARD',
    Franchise = 'FRANCHISE',
    Sustain = 'SUSTAIN',
}

export enum ProductTypes {
    Reporting = 'REPORTING',
    Forecasting = 'FORECASTING',
    Dashboard = 'DASHBOARD',
    Multi = 'MULTI',
    Sustain = 'SUSTAIN',
}

export enum DataSourceCodes {
    Xero = 'XERO',
    QuickBooks = 'QUICKBOOKS',
    QuickBooksDesktop = 'QUICKBOOKSDESKTOP',
    MYOBAccountRight = 'MYOBACCOUNTRIGHT',
    MYOBAccountRightDesktop = 'MYOBACCOUNTRIGHTDESKTOP',
    SageIntacct = 'SAGEINTACCT',
    Sage50Desktop = 'SAGE50DESKTOP',
    Excel = 'EXCEL',
    ExcelDesktop = 'EXCELDESKTOP',
    GoogleAnalytics = 'GOOGLEANALYTICS',
    GoogleAnalytics4 = 'GOOGLEANALYTICS4',
    GoogleSheets = 'GOOGLESHEETS',
    WorkFlowMax = 'WORKFLOWMAX',
    XeroPracticeManager = 'XEROPRACTICEMANAGER',
    PersonalWealth = 'PERSONALWEALTH',
    ExcelPersonalWealth = 'EXCELPERSONALWEALTH',
}

export enum DataSourceTypes {
    Cloud = 'CLOUD',
    Desktop = 'DESKTOP',
    Manual = 'MANUAL',
}

export enum ImportStatusCode {
    Pending = 'PENDING',
    NeverImported = 'NEVER',
    Importing = 'IMPORTING',
    Cancelled = 'CANCELLED',
    ImportFailed = 'IMPORTFAILED',
    ConnectFailed = 'CONNECTFAILED',
    Saving = 'SAVING',
    Waiting = 'WAITING',
    WaitingToCopyForecastTask = 'WAITING_TO_COPY_FORECAST_TASK',
    WaitingToCreateForecastTask = 'WAITING_TO_CREATE_FORECAST_TASK',
    WaitingToGenerateJournals = 'WAITING_TO_GENERATE_JOURNALS',
    WaitingToSyncForecastTaskData = 'WAITING_TO_SYNC_FORECAST_TASK_DATA',
    WaitingToUpdateForecastTaskSettings = 'WAITING_TO_UPDATE_FORECAST_TASK_SETTINGS',
    Running = 'RUNNING',
    Success = 'SUCCESS',
    Ready = 'READY',
    TimeOut = 'TIMEOUT',
    GANoProfiles = 'GANOPROFILES',
    MYOBSelectFile = 'MYOBSELECTFILE',
    NoTrackingSelected = 'NOTRACKINGSELECTED',
    CyclicalDependencies = 'CYCLICALDEPENDENCIES',
    NotRequired = 'NOTREQUIRED',
    Checking = 'CHECKING',
    UnknownError = 'UNKNOWNERROR',
    SuccessWithErrors = 'SUCCESSWITHERRORS',
}

export const FailInviteCustomerCareRequest = 'fail-customer-care-request';
